exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;justify-content:flex-end;margin:1rem 0}:host .filter-block{padding:0;margin:0}:host .filter-block label{word-spacing:.1em;font-weight:600;border:0;background-color:initial}:host .filter-block select.filter-block-custom-select{border-radius:0;min-width:10rem;border:1px solid #767676}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/home/mes-dossiers/filter-block/filter-block.component.scss
// module id = 693
// module chunks = 0